import { use, useEffect, useRef } from 'react';

import SpaceSettingsSaveContext from '../contexts/SpaceSettingsContext';

/**
 * Each settings section calls this to register its save handler.
 * The latest `save` is always used, without re-registering on every render.
 */
const useSectionSave = (
  id: string,
  save: () => Promise<void>,
  isDirty: boolean,
) => {
  const ctx = use(SpaceSettingsSaveContext);

  const saveRef = useRef(save);
  const dirtyRef = useRef(isDirty);

  useEffect(() => {
    saveRef.current = save;
    dirtyRef.current = isDirty;
  });

  useEffect(() => {
    if (!ctx) return;
    ctx.register({
      id,
      save: () => saveRef.current(),
      isDirty: () => dirtyRef.current,
    });
    return () => ctx.unregister(id);
  }, [ctx, id]);

  useEffect(() => {
    ctx?.setSectionDirty(id, isDirty);
  }, [ctx, id, isDirty]);
};

export default useSectionSave;
